module.exports = __webpack_public_path__ + "img/drizzle.149a8fe5.svg";